<script>
import Vue from 'vue'
import axios from 'axios'
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'

 import {
  required,
  minLength,
  maxLength,  
} from 'vuelidate/lib/validators' 


/**
 * Agregar Cuenta Component
 */
export default {
  components: { Layout, PageHeader},
  page: {
    title: 'Cuenta',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  data() {
    return {     
      title: 'Cuenta',
      form: {
        cuentaId: '',        
        descripcion: '',        
      },            
      items: [
        {
          text: 'Sistemas Tributario',
          href: '/',
        },
        {
          text: 'Cuenta',
          href: '/cuentas/',
        },
        {
          text: 'Nuevo',
          active: true,
        },
      ],
       submitted: false,
       isBusy: false
    }
  },
  validations: {
    form: {        
        descripcion: { required,
                    minLength: minLength(2),
                    maxLength: maxLength(50) },                     
        cuentaId: {                 
              required,
                                      
                  async isUniqueMail(value){
                    if (value === '') return true
                     let promise = axios
                        .get(appConfig.recursosApi.validacionCuentaDuplicada + value)
                        return promise
                                .then((response) => {
                                 
                                   return !response.data.existe
                                  
                                   })
                        .catch(()=>  {
                             
                              return false
               
                            }); 

                    }
                   },        
      
    },    
},
  computed:{
  
  },
  mounted(){
  },
   methods:{    
     _validations () {
      return new Promise(resolve => {
        if (this.$v.$error || !this.$v.$pending) {
          return resolve()
        }
        let poll = setInterval(() => {
          if (!this.$v.$pending) {
            clearInterval(poll)
            resolve()
          }
        }, 200)
      })
    },

    async isValid () {
      this.$v.$reset()
      this.$v.$touch()
      await this._validations()
      return Promise.resolve(!this.$v.$error)
    },
    
    async handleSubmit(e) {
      this.submitted = true;      
      const valid = await this.isValid();
      this.isBusy = false;
     
      if(valid){
        this.isBusy = true;
        axios
            .post(appConfig.recursosApi.cuenta , this.form)
            .then((response) => {
              this.isBusy = false;
               this.$router.push('/cuentas/index/true') ;
            }).catch(()=>  {
              
              this.isBusy = false;
               Vue.swal({
        type: 'error',
        title: 'Oops...',
        text: 'Ocurrio un error al intentar guardar los datos.',
        confirmButtonClass: 'btn btn-confirm mt-2',
        
      })
            });

      }
     
    },
   }
}
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
 <div class="row">
      <div class="col-lg-6">
        <div class="card-box">
          <h4 class="header-title m-t-0">Nueva Cuenta</h4>
          <p
            class="text-muted font-14 m-b-20"
          >Ingresa la información de la cuenta.</p>

          <form @submit.prevent="handleSubmit">            
            <!-- Datos Cuenta -->
            <div class="form-row"> 
                <div class="form-group col-md-4">
                    <label for="name">
                     No. Cuenta
                        <span class="text-danger">*</span>
                    </label>
                     <input
                    id="cuentaId"
                        v-model="form.cuentaId"
                        name="cuentaId"
                        class="form-control"
                        :class="{ 'is-invalid': submitted && $v.form.cuentaId.$error }"
                        type="text"
                        placeholder=""
                    />
                 <div
                    v-if="submitted && $v.form.cuentaId.$error" class="invalid-feedback" >
                     <span v-if="!$v.form.cuentaId.required"  >Debe indicar un numero de cuenta unico.</span>                    
                    <span v-if="!$v.form.cuentaId.isUnique">El numero de cuenta ya se se encuentra registrada.</span>
                    </div>
                    
                </div>
                <div class="form-group col-md-4">
                    <label>
                        Descripción
                        <span class="text-danger">*</span>
                    </label>
                    <input
                        v-model="form.descripcion"
                        type="text"
                        name="descripcion"
                        class="form-control"
                        :class="{ 'is-invalid': submitted && $v.form.descripcion.$error }"
                        placeholder=""/>
                        <div v-if="submitted && $v.form.correo.$error" class="invalid-feedback">
                            <span v-if="!$v.form.descripcion.required">Debe indicar la descripción de la cuenta.</span>
                        </div>
                </div>                
            </div>
           
          
            <div class="form-group text-right m-b-0">
              <button class="btn btn-primary" type="submit" :disabled="isBusy">   <b-spinner v-show="isBusy"  small></b-spinner>  Guardar</button>
              <router-link class="btn btn-secondary m-l-5 ml-1" to="/cuentas/index"> Cancelar</router-link>
            </div>
          </form>
        </div>
        <!-- end card-box -->
      </div>
 </div>
  </Layout>
</template>